import { useSeoMeta } from '@unhead/react';
import { Gavel } from 'lucide-react';
import { CraftProfileForm } from '@/components/CraftProfileForm';
import {
  SKATE_JUDGE_KIND,
  JUDGE_FORMAT_LABELS,
  JUDGE_SPECIALTY_LABELS,
  JUDGE_LEVEL_LABELS,
} from '@/lib/types';

export default function BecomeJudgePage() {
  useSeoMeta({
    title: 'Judge Skate Events - SkateSpots',
    description:
      'List yourself as a skate event judge — Game of S.K.A.T.E., best trick jams, contests, am series and world tour stops. Get booked to run fair, credible events.',
  });

  return (
    <CraftProfileForm
      config={{
        kind: SKATE_JUDGE_KIND,
        selfTag: 'skatejudge',
        identifier: 'judge-profile',
        heading: 'Skate Event Judge',
        tagline: 'From flat-ground Game of S.K.A.T.E. to the World Destruction Tour — run it fair, run it credible',
        noun: 'judge',
        accentText: 'text-yellow-400',
        accentBg: 'bg-yellow-500',
        accentChip: 'bg-yellow-500 text-black border-yellow-500',
        accentChipHover: 'hover:border-yellow-500/60 hover:text-yellow-400',
        icon: Gavel,
        rateLabel: 'Day Rate / Fee',
        portfolioLabel: 'Results archive / profile link',
        skillSections: [
          { title: 'Event Formats', entries: Object.entries(JUDGE_FORMAT_LABELS), required: true },
          { title: 'Specialty', entries: Object.entries(JUDGE_SPECIALTY_LABELS) },
          { title: 'Level / Circuit', entries: Object.entries(JUDGE_LEVEL_LABELS) },
        ],
        extraFields: [
          {
            tag: 'events_judged',
            label: 'Events Judged',
            placeholder: 'e.g. 40+ contests, 3 World Tour stops',
            helper: 'Notable events, comps or tours you have officiated.',
          },
        ],
      }}
    />
  );
}
